module.exports = __webpack_public_path__ + "static/media/emptyGraph.a27db917.svg";